import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1964124e")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AddressesList = _resolveComponent("AddressesList")!
  const _component_AddAddress = _resolveComponent("AddAddress")!
  const _component_EditAddress = _resolveComponent("EditAddress")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode(_component_AddressesList, { customerData: _ctx.customer }, null, 8, ["customerData"])
    ]),
    _createVNode(_component_AddAddress, { customerData: _ctx.customer }, null, 8, ["customerData"]),
    _createVNode(_component_EditAddress, { customerData: _ctx.customer }, null, 8, ["customerData"])
  ], 64))
})